import {Component, Input, OnInit} from '@angular/core';
import {Store} from '../../../../store';
import {FavouritesService} from '../../../../services/favourites.service';

@Component({
    selector: 'app-product-details-related-products',
    templateUrl: './product-details-related-products.component.html',
    styleUrls: ['./product-details-related-products.component.scss']
})
export class ProductDetailsRelatedProductsComponent implements OnInit {
    @Input() linkedProducts;
    @Input() deviceType;

    favourites$ = this.store.select<any[]>('favourites');

    constructor(
        private store: Store,
        private favouritesService: FavouritesService,
    ) {}

    ngOnInit(): void {
    }

    toggleFavourite(productId) {
        const favourites = this.store.selectForLocal('favourites');
        if (favourites.indexOf(productId) < 0) {
            this.favouritesService.addToFavourites(productId);
        } else {
            this.favouritesService.deleteFavourite(productId);
        }
    }
}
